import React, { useState } from "react";
import { FaUserMd, FaMinus, FaPlus, FaFileMedical, FaHeartbeat, FaHospitalUser, FaNotesMedical, FaStethoscope, FaBrain, FaLungs, FaCapsules, FaHospital, FaAmbulance, FaShieldAlt, FaSyringe, FaAppleAlt, FaRunning, FaHelicopter } from "react-icons/fa";
import Medpalm from "../../../assests/Healthcareprovider/preventive.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "icon": "<FaAmbulance className='text-[#2a627a] text-lg' />",
        "title": "Emergency Response",
        "description": "Our rapid-response ambulance services ensure quick arrival at emergency sites through real-time GPS tracking. Skilled paramedics provide pre-hospital care, including CPR, airway management, trauma stabilization, and wound care. Our teams are trained to assess and stabilize critical conditions such as cardiac arrest, stroke, and severe injuries before hospital admission, significantly improving patient survival rates."
    },
    {
        "icon": "<FaHospital className='text-[#2a627a] text-lg' />",
        "title": "24/7 Emergency Care",
        "description": "Our fully equipped emergency rooms operate round the clock to handle life-threatening situations, including severe trauma, heart attacks, strokes, and respiratory distress. Our dedicated emergency physicians, nurses, and trauma specialists provide immediate, high-quality medical intervention using cutting-edge diagnostic tools, ensuring rapid and effective treatment for all urgent medical conditions."
    },
    {
        "icon": "<FaUserMd className='text-[#2a627a] text-lg' />",
        "title": "Critical Care & Trauma Services",
        "description": "We offer specialized critical care for patients in life-threatening conditions, including multi-organ failure, sepsis, and severe injuries. Our trauma centers are equipped with advanced life-support systems, including ventilators, defibrillators, and real-time patient monitoring. Our multidisciplinary teams provide rapid assessments, emergency surgeries, and continuous intensive care to optimize recovery outcomes."
    },
    {
        "icon": "<FaHeartbeat className='text-[#2a627a] text-lg' />",
        "title": "Cardiac & Stroke Emergency",
        "description": "Our specialized cardiac and stroke emergency response teams deliver rapid, evidence-based treatment to minimize damage and improve survival. For heart attacks, we provide advanced cardiac catheterization, defibrillation, and thrombolytic therapy. Stroke patients receive immediate intervention with clot-dissolving medications and advanced neuroimaging to prevent long-term disabilities and maximize recovery."
    },
    {
        "icon": "<FaHelicopter className='text-[#2a627a] text-lg' />",
        "title": "Air Ambulance Services",
        "description": "We provide fast and efficient air ambulance services for critically ill or severely injured patients requiring immediate medical attention at specialized hospitals. Our aircraft are equipped with ICU-level care, including oxygen support, cardiac monitoring, and onboard medical teams trained in advanced resuscitation. Air transport is ideal for remote or disaster-stricken areas where timely medical evacuation can save lives."
    },
    {
        "icon": "<FaCapsules className='text-[#2a627a] text-lg' />",
        "title": "Emergency Medication & Treatment",
        "description": "Our emergency medical teams provide immediate administration of life-saving medications, including epinephrine for severe allergic reactions, IV fluids for dehydration and shock, and pain management for critical injuries. Our protocols ensure rapid response for poisoning cases, infections, and respiratory distress, stabilizing patients before hospital admission."
    },
    {
        "icon": "<FaFileMedical className='text-[#2a627a] text-lg' />",
        "title": "Real-time Patient Monitoring",
        "description": "Our state-of-the-art real-time patient monitoring systems track vital signs such as heart rate, oxygen levels, and blood pressure during transport and hospital care. Using portable ECGs, pulse oximeters, and automated defibrillators, we ensure continuous assessment of critical patients. This allows for immediate intervention when necessary, significantly improving emergency response outcomes."
    },
    {
        "icon": "<FaShieldAlt className='text-[#2a627a] text-lg' />",
        "title": "Disaster & Mass Casualty Management",
        "description": "Our disaster response teams are trained to handle large-scale emergencies, including natural disasters, industrial accidents, and mass casualty events. We deploy mobile emergency units, crisis intervention teams, and triage systems to efficiently assess, stabilize, and treat large numbers of patients. Our coordinated approach ensures maximum survival and effective management of high-impact emergencies."
    }
]


const features = [
    { icon: <FaStethoscope className="text-[#2a627a] text-lg" />, text: "Early disease detection with routine screenings and tests." },
    { icon: <FaSyringe className="text-[#2a627a] text-lg" />, text: "Immunization programs to prevent infectious diseases." },
    { icon: <FaAppleAlt className="text-[#2a627a] text-lg" />, text: "Healthy lifestyle guidance through nutrition and fitness programs." },
    { icon: <FaBrain className="text-[#2a627a] text-lg" />, text: "Mental health support for stress management and emotional well-being." },
    { icon: <FaLungs className="text-[#2a627a] text-lg" />, text: "Proactive lung health monitoring and smoking cessation support." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Personalized health risk assessments based on genetic history." }
];

const benefits = [
    { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Reduces the risk of chronic diseases with early intervention." },
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Encourages healthier lifestyles through preventive care programs." },
    { icon: <FaCapsules className="text-[#2a627a] text-lg" />, text: "Lowers healthcare costs by preventing serious illnesses." },
    { icon: <FaHospitalUser className="text-[#2a627a] text-lg" />, text: "Improves overall quality of life with proactive health management." },
    { icon: <FaSyringe className="text-[#2a627a] text-lg" />, text: "Prevents the spread of infectious diseases through vaccinations." },
    { icon: <FaBrain className="text-[#2a627a] text-lg" />, text: "Enhances mental well-being by promoting emotional resilience." }
];
const cmsFeatures = [
    {
        icon: <FaUserMd className="text-[#2a627a] text-lg" />,
        role: "Primary Care Physician",
        text: "Conducts routine check-ups, monitors health risks, and provides preventive care recommendations."
    },
    {
        icon: <FaSyringe className="text-[#2a627a] text-lg" />,
        role: "Immunization Specialist",
        text: "Administers vaccines, tracks immunization schedules, and educates patients on disease prevention."
    },
    {
        icon: <FaAppleAlt className="text-[#2a627a] text-lg" />,
        role: "Dietitian & Nutritionist",
        text: "Provides personalized meal plans and lifestyle coaching to support preventive health goals."
    },
    {
        icon: <FaRunning className="text-[#2a627a] text-lg" />,
        role: "Fitness Trainer",
        text: "Develops exercise programs to help patients maintain optimal physical health and prevent diseases."
    },
    {
        icon: <FaBrain className="text-[#2a627a] text-lg" />,
        role: "Mental Health Counselor",
        text: "Offers therapy sessions and stress management strategies for better emotional and psychological well-being."
    },
    {
        icon: <FaFileMedical className="text-[#2a627a] text-lg" />,
        role: "Preventive Health Coordinator",
        text: "Organizes health screenings, tracks preventive care plans, and ensures patient follow-ups."
    }
];

const PreventiveHealthcare = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex">PreventiveHealthcare  - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Proactively promoting wellness and early detection to reduce the risk of diseases and improve long-term health outcomes."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]"> What is Preventive Healthcare?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Preventive healthcare focuses on early detection, routine screenings, vaccinations, and lifestyle management to reduce disease risks and promote long-term well-being.

                            At HIKEHEALTH GS, we empower preventive care with digital health solutions, enabling proactive monitoring, personalized insights, and better health outcomes.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Preventive Healthcare
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default PreventiveHealthcare;
